<script setup lang="ts">
import { Link } from '@inertiajs/vue3'

import { adminRootPath } from '@/routes'

defineProps<{
  title?: string
  description?: string
}>()
</script>

<template>
  <div
    class="bg-default text-default flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10"
  >
    <div class="w-full max-w-sm">
      <div class="flex flex-col gap-8">
        <div class="flex flex-col items-center gap-4">
          <Link
            :href="adminRootPath()"
            class="flex flex-col items-center gap-2 font-medium"
          >
            <div
              class="mb-1 flex size-14 items-center justify-center rounded-md"
            />
            <span class="sr-only">{{ title }}</span>
          </Link>
          <div class="space-y-2 text-center">
            <h1 class="text-xl font-medium">
              {{ title }}
            </h1>
            <p class="text-muted text-center text-sm">
              {{ description }}
            </p>
          </div>
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>
